const PostLogslocal = (data, cb) => {
  fetch(`${process.env.REACT_APP_API_LOG}/api/v1/logs`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: data,
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};
export default PostLogslocal;